<template>
  <div class="customerMessage">
    <div class="before-connect">
      <!-- <span @click="back" class="el-icon-arrow-left">返回</span> -->
      <div class="content">留言板</div>
    </div>
    <div class="messageform">
      <el-form
        class="form"
        label-width="100px"
        :rules="rules"
        ref="form"
        label-position="right"
        :model="form"
      >
        <el-form-item label="客户账号">
          <el-input
            v-model="userName"
            placeholder="客户账号"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item prop="lastName" class="firstName" label="姓">
          <el-input
            v-model="form.lastName"
            maxlength="10"
            @focus="clearError('lastName')"
            style="float:left;margin-right:10px;"
            placeholder="姓"
          ></el-input>
        </el-form-item>
        <el-form-item prop="cusGender" class="sex" label="性别">
          <el-radio-group v-model="form.cusGender">
            <el-radio :label="0">先生</el-radio>
            <el-radio :label="1">女士</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="chatType" label="咨询问题">
          <el-select v-model="form.chatType" placeholder="咨询问题">
            <el-option
              v-for="item in chatTypes"
              :key="item.id"
              :label="item.name"
              :value="item.uid"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="留言内容" prop="message">
          <el-input
            type="textarea"
            resize="none"
            rows="5"
            maxlength="300"
            @input="this.descInput"
            @focus="clearError('message')"
            v-model="form.message"
            :placeholder="
              getmessage.content == '' ? '留言内容' : getmessage.content
            "
          ></el-input>
          <span style="float:right;color:#B2B2B2;margin-right:20px;"
            >{{ this.remnant }}/300</span
          >
        </el-form-item>
        <el-form-item
          label="留言图片"
          class="upload"
          style="border:none;margin:10px 0;"
        >
          <el-upload
            class="upload-area fl"
            :class="{ hide: hideUploadEdit }"
            :action="uploadApi"
            :headers="headers"
            list-type="picture-card"
            :on-exceed="handleExceed"
            :before-upload="beforeUpload"
            :on-success="handleSuccess"
            :on-change="handleEditChange"
            :on-remove="handleRemove"
            :on-error="handleError"
            :limit="limit"
            name="uploadFile"
            :data="params"
            :multiple="false"
            :drag="true"
            :file-list="fileList"
          >
            <i class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <img
                class="el-upload-list__item-thumbnail"
                @click="clickbanner"
                :src="file.url"
                @error="errorimg(file)"
                alt="图片"
              />
              <i class="el-icon-error" @click="handleRemove(file)"></i>
              <div v-if="file.status == 'success'" class="tip">上传成功</div>
              <div v-if="file.status == 'uploading'" class="tip">上传中</div>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="手机号"
          prop="phone"
          class="phone"
          :required="getmessage.typePhone == 2 ? true : false"
          v-if="getmessage.typePhone == 1 || getmessage.typePhone == 2"
        >
          <el-input
            v-model="form.phone"
            maxlength="11"
            @focus="clearError('phone')"
            placeholder="手机号"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="weChat"
          v-if="getmessage.typeWeChat == 1 || getmessage.typeWeChat == 2"
          :required="getmessage.typeWeChat == 2 ? true : false"
          label="微信"
          class="wechat"
        >
          <el-input
            v-model="form.weChat"
            @focus="clearError('weChat')"
            maxlength="19"
            placeholder="微信"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="QQ"
          prop="qq"
          :required="getmessage.typeQQ == 2 ? true : false"
          v-if="getmessage.typeQQ == 1 || getmessage.typeQQ == 2"
          class="qq"
        >
          <el-input
            v-model="form.qq"
            @focus="clearError('qq')"
            placeholder="QQ"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <div style="text-align:center;">
          <el-button
            style="width:120px;margin-top:15px;margin-bottom:15px;"
            class="submit_btn"
            :disabled="disabled_btn"
            type="primary"
            @click="submit"
            >提交</el-button
          >
        </div>
        <!-- <span class="submit_btn" @click="submit">提交</span> -->
      </el-form>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialog"
      width="80%"
      top="20vh"
      :modal-append-to-body="false"
      center
    >
      <p>您今天留言次数已超过限制。</p>
      <p>如有需求，请联系在线客服或明天再来留言。</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="close">好的，我知道了</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="80%"
      top="20vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :modal-append-to-body="false"
    >
      <i class="el-icon-circle-check"></i><br />
      <span>留言已提交成功</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="close">好的</el-button>
      </span>
    </el-dialog>
    <CoolLightBox
      :slideshow="isshow"
      :items="uploadImages"
      :index="index"
      @close="closeImg"
    />
  </div>
</template>
<script>
import utils from "../../utils";
import request from "../../utils/request";
import transferUploadImg from "src/mixins/transferUploadImg";
export default {
  name: "customerMessage",
  mixins: [transferUploadImg],
  data() {
    let validateName = (rule, value, callback) => {
      if (
        value === "" &&
        rule.field == "phone" &&
        this.getmessage.typePhone == 2
      ) {
        callback(new Error("请输入手机号"));
      } else if (
        value === "" &&
        rule.field == "weChat" &&
        this.getmessage.typeWeChat == 2
      ) {
        callback(new Error("请输入微信号"));
      } else if (
        value === "" &&
        rule.field == "qq" &&
        this.getmessage.typeQQ == 2
      ) {
        callback(new Error("请输入QQ号"));
      } else {
        callback();
      }
    };
    return {
      time: null,
      hideUploadEdit: false,
      isshow: false,
      uploadImages: [],
      fileList: [],
      index: null,
      limit: 3,
      dialogVisible: false,
      disabled_btn: false,
      chatTypes: [],
      count: null,
      dialog: false,
      getmessage: {},
      remnant: 300,
      form: {
        lastName: "",
        cusGender: 0,
        chatType: null,
        message: "",
        phone: "",
        qq: "",
        weChat: "",
        messagePicture: ""
      },
      rules: {
        lastName: [
          { required: true, message: "请输入您的姓", trigger: "blur" }
        ],
        cusGender: [{ required: true, trigger: "blur" }],
        chatType: {
          required: true,
          message: "请选择咨询问题",
          trigger: ["change", "blur"]
        },
        message: [
          { required: true, message: "请输入留言内容", trigger: "blur" }
        ],
        phone: [
          { validator: validateName },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号不正确",
            trigger: "blur"
          }
        ],
        weChat: [{ validator: validateName }],
        qq: [
          { validator: validateName },
          {
            pattern: /^[1-9]\d{4,10}$/,
            message: "QQ号不正确",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      customerInfo: state => state.customerInfo,
      userId: state => state.userId,
      domain: state => state.domain
    })
  },
  async created() {
    if (this.domain && this.domain.API_URL) {
      request.defaults.baseURL = this.domain.API_URL;
    } else {
      request.defaults.baseURL = process.env.VUE_APP_CUST_BASEURL;
    }
    (this.form.userId = this.userId),
      utils.getcustomer().then(res => {
        this.chatTypes = res.data.chatType;
        this.getmessage = res.data;
        if (res.data.leaveType == 1) {
          this.dialog = true;
        }
      });
    if (this.customerInfo.type == 2) {
      this.userName = "游客";
    } else {
      this.userName = this.customerInfo.userName;
    }
    utils.forbidMoveLeft();
  },
  methods: {
    errorimg(file) {
      this.$message.error("文件无效（0kb）或格式不正确，请重新选择正确文件");
      this.handleRemove(file);
      return false;
    },
    removeImg() {
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        this.hideUploadEdit = this.fileList.length >= this.limit;
      }, 500);
    },
    handleEditChange(file, fileList) {
      this.fileList = fileList;
      console.log(file, fileList, fileList.length);
      this.hideUploadEdit = fileList.length >= this.limit;
    },
    clickbanner(e) {
      console.log(e.target.currentSrc);
      for (let i = 0; i < this.fileList.length; i++) {
        if (e.target.currentSrc == this.fileList[i].url) {
          this.index = i;
          console.log(this.index);
        }
        var obj = {};
        obj["src"] = this.fileList[i].url;
        this.uploadImages.push(obj);
      }
      this.isshow = true;
    },
    closeImg() {
      //关闭图片事件
      this.index = null;
      this.uploadImages = [];
    },
    descInput() {
      var txtVal = this.form.message.length;
      if (this.form.message.length > 300) {
        this.form.message = this.form.message.slice(0, 300);
        this.remnant = 0;
      } else {
        this.remnant = 300 - txtVal;
      }
    },
    clearError(name) {
      this.$refs["form"].clearValidate([name]);
    },
    back() {
      utils.closePage();
    },
    close() {
      this.dialog = false;
      utils.closePage();
    },
    submit() {
      this.form.messagePicture = "";
      this.fileList.forEach(element => {
        this.form.messagePicture += element.response.data[0].url + ",";
      });
      if (
        this.form.messagePicture[this.form.messagePicture.length - 1] == ","
      ) {
        this.form.messagePicture = this.form.messagePicture.substring(
          0,
          this.form.messagePicture.length - 1
        );
      }
      this.disabled_btn = true;
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.getmessage.leaveType == 1) {
            this.dialog = true;
          } else {
            utils.savecustomerMessage(this.form).then(res => {
              this.disabled_btn = false;
              if (res.data.code == "200") {
                this.dialogVisible = true;
                this.drawer = false;
              } else if (res.data.code == "1020") {
                this.dialog = true;
              }
            });
          }
        } else {
          this.disabled_btn = false;
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  destroyed() {
    clearTimeout(this.time);
  }
};
</script>
<style lang="less">
.upload .el-form-item__label {
  position: relative;
  top: 20px;
}
.customerMessage {
  height: 100vh;
  background: #fff;
  .el-dialog__body {
    text-align: center !important;
    .el-icon-circle-check {
      font-size: 30px;
      margin-bottom: 10px;
      color: #67c23a;
    }
  }
}
.firstName .el-form-item__label:before {
  position: relative;
  left: -42px;
}
.sex .el-form-item__label:before,
.wechat .el-form-item__label:before {
  position: relative;
  left: -28px;
}
.phone .el-form-item__label:before {
  position: relative;
  left: -14px;
}
.qq .el-form-item__label:before {
  position: relative;
  left: -32px;
}
</style>
<style scoped lang="less">
// 上传图片
.tip {
  color: #fff;
  z-index: 64;
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  background: rgba(0, 0, 0, 0.8);
  height: 16px;
  line-height: 16px;
  font-size: 11px;
}
.upload-wrapper {
  width: 100%;
  padding: 0 15px;
  background-color: #fff;
  transition-duration: 0.3s;
  visibility: hidden;
  height: 0;
  opacity: 0;

  &.show {
    visibility: visible;
    height: auto;
    min-height: 120px;
    opacity: 1;
  }
  .el-upload {
    display: inline-flex;
    width: 20.4vw;
    height: 20.4vw;
    justify-content: center;
    align-items: center;
    .el-icon-plus {
      color: var(--loadimg-add-icon);
      &:active {
        color: var(--loadimg-add-click);
      }
    }
  }

  .el-upload-list__item {
    width: 60px;
    height: 60px;
    position: relative;
    img {
      max-width: 100%;
      height: auto;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
  }

  .el-upload--picture-card {
    width: 20.4vw;
    height: 20.4vw;
    i {
      color: #3a88ef;
    }
    &:active {
      border: 0px dashed var(--loadimg-add-click);
    }
  }
}
</style>
<style lang="less">
.hide .el-upload--picture-card {
  display: none;
}
.customerMessage .el-upload--picture-card,
.customerMessage .el-upload-list__item {
  width: 20.4vw !important;
  height: 20.4vw !important;
}
.customerMessage .el-upload-dragger {
  width: 20.4vw !important;
  height: 20.4vw !important;
  display: flex;
  justify-content: center;
  align-items: center;
  // border: 0;
}
.upload .el-upload-list__item img {
  max-width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.mobile {
  .main {
    .customerMessage {
      background: #fff;
      z-index: 222;
      .el-form-item {
        margin-bottom: 10px;
        margin-right: 10px;
      }
    }
    .el-dialog__body p {
      line-height: 20px;
    }
    .el-select {
      width: 150px;
    }
    .el-button--primary {
      background: var(--header-bg);
      border: none;
    }
    // background:#fff!important;
    .el-form-item {
      // border-bottom: 1px solid #e5e5e5;
      // padding:10px 0 18px;
      // margin-bottom: 0;
      // .el-textarea__inner,
      // .el-input__inner {
      //   border: none !important;
      // }
      .el-radio__input.is-checked + .el-radio__label {
        color: var(--header-bg) !important;
      }
      .el-radio__input.is-checked .el-radio__inner {
        background: var(--header-bg) !important;
        border-color: var(--header-bg) !important;
      }
    }
    .el-form-item__error {
      right: 10px;
      left: auto;
      top: 10px;
    }
  }
}
</style>
<style lang="less" scoped>
.customerMessage {
  .form {
    position: relative;
    left: 0;
    top: 8vh;
    bottom: 0;
  }
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 20px;
    background-color: #c1c1c1;
  }
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background-color: #ebebeb;
  }
}
.before-connect {
  font-family: PingFang TC;
  font-style: normal;
  font-size: 13px;
  line-height: 8vh;
  height: 8vh;
  text-align: center;
  color: var(--button-text);
  background: var(--header-bg);
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  .el-icon-arrow-left {
    position: absolute;
    cursor: pointer;
    left: 15px;
    top: 6.5vw;
  }
  .submit_btn {
    position: absolute;
    cursor: pointer;
    right: 15px;
    top: 0;
  }
}
</style>
